import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { listRefundPending } from '../api/financeApi';
import useFinanceQuery from '../useFinanceQuery';
import FinanceListPage from '../components/FinanceListPage';
import DetailLinkButton from '../components/DetailLinkButton';
import MarkRefundSentModal from '../components/MarkRefundSentModal';
import { useFinance } from '../financeContext';
import { money, dateStr } from '../format';

export default function RefundsPendingPage() {
  const { canApproveFinance } = useFinance();
  const q = useFinanceQuery(
    (params) => listRefundPending(params),
    { filterKeys: ['vertical', 'minAmount', 'maxAmount', 'dateFrom', 'dateTo'] }
  );
  const [refundBookingId, setRefundBookingId] = useState(null);

  const columns = [
    { key: 'ref', header: 'Booking', cardHeader: true, cell: (r) => <DetailLinkButton kind="booking" entity={r} /> },
    { key: 'vertical', header: 'Vertical', cell: (r) => r.vertical },
    { key: 'customer', header: 'Customer', cell: (r) => r.customerName },
    { key: 'deposit', header: 'Deposit', cell: (r) => money(r.depositAmount) },
    { key: 'since', header: 'Since', cell: (r) => dateStr(r.updatedAt) }
  ];

  const rowActions = !canApproveFinance ? undefined : (r) => (
    <Button size="sm" variant="warning" onClick={() => setRefundBookingId(r._id)}>Mark sent</Button>
  );

  return (
    <>
      <FinanceListPage
        title="Refunds pending"
        subtitle="Security deposits waiting to be returned to the customer."
        q={q}
        columns={columns}
        rowActions={rowActions}
        filterFields={['vertical', 'amount', 'date']}
        searchPlaceholder="Search booking or customer"
        emptyText="No refunds waiting to be sent."
      />
      <MarkRefundSentModal
        bookingId={refundBookingId}
        show={!!refundBookingId}
        onHide={() => setRefundBookingId(null)}
        onSent={() => { setRefundBookingId(null); q.reload(); }}
      />
    </>
  );
}
